/**
 * Load a Google Fonts stylesheet once per href. Shared by the public
 * renderer (a design's own fonts) and the editor's design picker
 * (every design's display face).
 */
import { useEffect } from 'react';

export function useGoogleFonts(href: string | null) {
  useEffect(() => {
    if (!href || typeof document === 'undefined') return;
    const id = `gal-fonts-${btoa(href).replace(/[^a-z0-9]/gi, '').slice(0, 24)}`;
    if (document.getElementById(id)) return;
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://fonts.gstatic.com';
    preconnect.crossOrigin = 'anonymous';
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    document.head.append(preconnect, link);
    // Fonts stay loaded for the tab; removing them on unmount would
    // only cause a flash when the viewer navigates back.
  }, [href]);
}
